/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */
export {
  hostDetector,
  osDetector,
  processDetector,
  serviceInstanceIdDetector,
} from './node';
